export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/chatbots.de81479.svg";